import URLConfig from '@Config/urls/url.config';

export default function generateDetailsPageLink(rootUrl:string, id: string, page:string): string {
    return rootUrl + id + page;
}